'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M832 320c0-50.638-39.214-92.090-88.93-95.712 32.592-37.716 31.012-94.754-4.796-130.562-35.806-35.808-92.846-37.388-130.558-4.798-3.626-49.714-45.076-88.928-95.716-88.928s-92.088 39.214-95.712 88.928c-37.714-32.59-94.754-31.008-130.562 4.798-35.806 35.808-37.388 92.846-4.798 130.562-49.712 3.624-88.928 45.074-88.928 95.712s39.214 92.088 88.928 95.712c-32.59 37.714-31.008 94.754 4.798 130.56 26.588 26.588 64.878 34.288 98.274 23.154v422.574l128-128 128 128v-422.572c33.396 11.13 71.686 3.436 98.274-23.154 35.808-35.806 37.388-92.844 4.796-130.56 49.716-3.624 88.93-45.076 88.93-95.714zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192c106.040 0 192 85.96 192 192s-85.96 192-192 192z' })
    ));
};